import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { MenuItem } from '@mui/material';
import Menu from '@mui/material/Menu';

import {
    ADVISER,
    hasRole,
    LOCAL_ADMIN,
    MANAGER,
    PRAP,
    QUALITY,
    RECRUITMENT_MANAGER,
    SUPERUSER
} from '../../utils/userRoles';
import DataSets from '../dataSets/DataSets';
import PolarisLink from '../ui/PolarisLink';
import BatchUploader from '../uploaders/batchUploader/BatchUploader';
import ClaimStatusUploader from '../uploaders/claimStatusUploader/ClaimStatusUploader';
import NdppUploader from '../uploaders/ndppUploader/NdppUploader';
import WebsiteUploaderModal from '../uploaders/websiteUploader/WebsiteUploaderModal';

const allButReadAndAudit = [
    ADVISER,
    LOCAL_ADMIN,
    MANAGER,
    PRAP,
    QUALITY,
    RECRUITMENT_MANAGER,
    SUPERUSER
];

const JourneyMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [showBatchUploader, setShowBatchUploader] = useState(false);
    const [showNdppUploader, setShowNdppUploader] = useState(false);
    const [showClaimStatusUploader, setShowClaimStatusUploader] = useState(false);
    const [showDataSets, setShowDataSets] = useState(false);
    const [showWebsiteUploader, setShowWebsiteUploader] = useState(false);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const { roles } = useSelector((state) => state.entities.userService.loggedInUser);
    const handleClickListItem = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleMenuItemClick = (index) => {
        switch (index) {
            case 0:
                navigate('/recruitment_management');
                break;
            case 1:
                navigate('/course_management');
                break;
            case 2:
                navigate('/create_course_template', { state: { accordionPanel: 'templates' } });
                break;
            case 3:
                navigate('/create_provision', { state: { accordionPanel: 'provisions' } });
                break;
            case 4:
                navigate('/claims');
                break;
            case 5:
                setShowDataSets(true);
                navigate('/home');
                break;
            case 6:
                setShowClaimStatusUploader(true);
                navigate('/home');
                break;
            case 7:
                setShowBatchUploader(true);
                navigate('/home');
                break;
            case 8:
                setShowNdppUploader(true);
                navigate('/home');
                break;
            case 9:
                setShowWebsiteUploader(true);
                navigate('/home');
                break;
            default:
                break;
        }
        setAnchorEl(null);
    };

    return (
        <div>
            <PolarisLink id="journeyNav" label={'Journey'} onClick={handleClickListItem} />

            <Menu
                id="menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    menuList: {
                        'aria-labelledby': 'lock-button',
                        role: 'listbox'
                    }
                }}>
                <MenuItem key={0} id="recruitmentManagementNav" onClick={() => handleMenuItemClick(0)}>
                    Recruitment Management
                </MenuItem>
                <MenuItem key={1} id="courseManagementNav" onClick={() => handleMenuItemClick(1)}>
                    Course Management
                </MenuItem>
                <MenuItem
                    key={2}
                    id="createCourseTemplateNav"
                    onClick={() => handleMenuItemClick(2)}
                    disabled={!hasRole([QUALITY, SUPERUSER, LOCAL_ADMIN], roles)}>
                    Create Course Template
                </MenuItem>
                <MenuItem key={3} id="createProvisionNav" onClick={() => handleMenuItemClick(3)}>
                    Create Provision
                </MenuItem>
                <MenuItem
                    key={4}
                    id="claimQueueNav"
                    onClick={() => handleMenuItemClick(4)}
                    disabled={!hasRole([MANAGER, PRAP, QUALITY, SUPERUSER], roles)}>
                    Claim Queue
                </MenuItem>
                <MenuItem
                    key={5}
                    id="dataSetsNav"
                    onClick={() => handleMenuItemClick(5)}
                    disabled={
                        !hasRole(
                            [ADVISER, MANAGER, PRAP, QUALITY, RECRUITMENT_MANAGER, SUPERUSER],
                            roles
                        )
                    }>
                    Data Sets
                </MenuItem>
                <MenuItem
                    key={6}
                    id="claimStatusUploaderNav"
                    onClick={() => handleMenuItemClick(6)}
                    disabled={!hasRole([PRAP, QUALITY, SUPERUSER], roles)}>
                    Claim Status Uploader
                </MenuItem>
                <MenuItem
                    key={7}
                    id="batchUploaderNav"
                    onClick={() => handleMenuItemClick(7)}
                    disabled={!hasRole([PRAP, QUALITY, SUPERUSER], roles)}>
                    Batch Uploader
                </MenuItem>
                <MenuItem
                    key={8}
                    id="ndppUploaderNav"
                    onClick={() => handleMenuItemClick(8)}
                    disabled={!hasRole(allButReadAndAudit, roles)}>
                    NDPP Uploader
                </MenuItem>
                <MenuItem
                    key={9}
                    id="websiteUploaderNav"
                    onClick={() => handleMenuItemClick(9)}
                    disabled={!hasRole(allButReadAndAudit, roles)}>
                    Website Uploader
                </MenuItem>
            </Menu>

            <div>
                {showDataSets && (
                    <DataSets isOpen={showDataSets} onClose={() => setShowDataSets(false)} />
                )}
                {showBatchUploader && (
                    <BatchUploader
                        isOpen={showBatchUploader}
                        onClose={() => setShowBatchUploader(false)}
                    />
                )}
                {showClaimStatusUploader && (
                    <ClaimStatusUploader
                        isOpen={showClaimStatusUploader}
                        onClose={() => setShowClaimStatusUploader(false)}
                    />
                )}
                {showNdppUploader && (
                    <NdppUploader
                        isOpen={showNdppUploader}
                        onClose={() => setShowNdppUploader(false)}
                    />
                )}
                {showWebsiteUploader && (
                    <WebsiteUploaderModal
                        isOpen={showWebsiteUploader}
                        onClose={() => setShowWebsiteUploader(false)}
                    />
                )}
            </div>
        </div>
    );
};
export default JourneyMenu;
